export default __webpack_public_path__ + "static/media/bitwallet-bdSwiss-dark.fc4ecafd.svg";